import { FC, useState } from 'react'
import styled from 'styled-components'
import { RangeSlider } from 'ui/range-slider'

export type Props = {
  title: string
  min: number
  max: number
  onSubmit: (value: number) => void
  value: number
  step?: number
  name?: string
}

export const Parameter: FC<Props> = ({ title, min, max, onSubmit, value, step = 1 }) => {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <RangeSlider
        min={min}
        max={max}
        value={{ from: value, to: max }}
        single={true}
        inputSize="small"
        onSubmit={(value) => onSubmit(value.from)}
        step={step}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-bottom: 2.4rem;
`

const Title = styled.p`
  margin-top: 0;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.palette.grey[600]};
  ${({ theme }) => theme.textStyles.p1};
`
